import { c as _c } from "react/compiler-runtime";
import React from "react";
import Link from "next/link";
export interface CtaButtonProps {
  href: string;
  isExternal: boolean;
  text: string;
  backgroundColor: string;
  textColor: string;
  /** Use pill shape (rounded-full) instead of rounded-md */
  rounded?: boolean;
}
export const CtaButton: React.FC<CtaButtonProps> = t0 => {
  const $ = _c(13);
  const {
    href,
    isExternal,
    text,
    backgroundColor,
    textColor,
    rounded
  } = t0;
  const className = `w-full md:w-auto text-center px-6 py-3 ${rounded ? "rounded-full" : "rounded-md"} font-bold text-sm hover:opacity-90 transition-opacity`;
  let t1;
  if ($[0] !== backgroundColor || $[1] !== textColor) {
    t1 = {
      backgroundColor,
      color: textColor
    };
    $[0] = backgroundColor;
    $[1] = textColor;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const style = t1;
  if (isExternal) {
    let t2;
    if ($[3] !== className || $[4] !== href || $[5] !== style || $[6] !== text) {
      t2 = <a href={href} target="_blank" rel="noopener noreferrer" className={className} style={style}>{text}</a>;
      $[3] = className;
      $[4] = href;
      $[5] = style;
      $[6] = text;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  let t2;
  if ($[8] !== className || $[9] !== href || $[10] !== style || $[11] !== text) {
    t2 = <Link prefetch={false} href={href} className={className} style={style}>{text}</Link>;
    $[8] = className;
    $[9] = href;
    $[10] = style;
    $[11] = text;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};